import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, map } from 'rxjs';

@Injectable()
export class FocusManagerService {
  focused = new BehaviorSubject<HTMLElement | null>(null);
  isCurrentWindowBlurred$ = fromEvent(window, 'blur').pipe(map(() => true));
  focus(element: HTMLElement | null): void {
    this.focused.next(element);
  }

  isFocused(element: HTMLElement): boolean {
    return this.focused.value === element;
  }
}
